<template>
  <div>
    <div class="msg-push-info">
      <div class="title">版位基本信息</div>
      <div class="flex">
        <div class="img mr10">
          <el-image style="width: 100%" :src="msgInfo.img" fit="fit"></el-image>
        </div>
        <div class="flex-1 flex flex-column flex-center">
          <div class="flex msg-info">
            <div class="flex-1" style="font-size: 16px; font-weight: bold">
              版位名称：{{ paramsInfo.pathName }}
            </div>

            <div class="flex-1 flex">
              推荐类型：个性化推荐
              <div v-if="planInfoModel.planStatus === 'notStart'" class="gray">
                未开始
              </div>
              <div
                v-else-if="planInfoModel.planStatus === 'running'"
                class="success"
              >
                进行中
              </div>
              <div v-else-if="planInfoModel.planStatus === 'end'" class="gray">
                已结束
              </div>
              <div
                v-else-if="planInfoModel.planStatus === 'errorStop'"
                class="danger"
              >
                异常暂停
              </div>
              <div
                v-else-if="planInfoModel.planStatus === 'stop'"
                class="orange"
              >
                暂停
              </div>
            </div>
          </div>
          <div class="flex mt10 msg-info">
            <div class="flex-1">权益礼包：{{ "无" }}</div>
            <!-- <div class="flex-1"></div>
            <div class="flex-1"></div>
            <div class="flex-1"></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="msg-push-info" style="padding-bottom: 50px">
      <div class="title">推荐数据效果</div>
      <div class="flex flex-end">
        <div style="margin-right: 10px">
          <el-button
            type="primary"
            @click="oldData(1)"
            :class="timeTable == 1 ? 'button-activy' : 'not-button-activy'"
            >昨天</el-button
          >
        </div>
        <div style="margin-right: 10px">
          <el-button
            type="primary"
            @click="oldData(7)"
            :class="timeTable == 2 ? 'button-activy' : 'not-button-activy'"
            >过去7天</el-button
          >
        </div>
        <div style="margin-right: 20px">
          <el-button
            type="primary"
            @click="oldData(30)"
            :class="timeTable == 3 ? 'button-activy' : 'not-button-activy'"
            >过去30天</el-button
          >
        </div>
        <el-date-picker
          clearable
          v-model="createTimeArry"
          align="right"
          size="small"
          class="mr10"
          :picker-options="pickerOptions"
          @change="createTimeArryChange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </div>

      <div class="flex flex-center mt20">
        <div
          class="flex-1 flex purchase-data p10 pointer"
          :class="{ mr20: i < list.length - 1 }"
          v-for="(v, i) in list"
          :key="i"
          @click="gogogo(v)"
        >
          <div class="hm-icon mr10">
            <span class="hmicon" :class="v.icon"></span>
          </div>
          <div class="flex-1">
            <el-tooltip
              class="tooltip"
              effect="light"
              :content="v.tip"
              placement="top"
            >
              <div class="purchase-name mt10 flex item-center">
                {{ v.name }}

                <i
                  class="el-icon-question"
                  style="font-size: 18px;"
                ></i>
              </div>
            </el-tooltip>
            <div class="mt10 flex flex-between item-center">
              <div class="purchase-val" v-if="i === 4">
                ￥{{ toPriceNum(v.val.toFixed(2)) }}
              </div>
              <div class="purchase-val" v-else>
                {{ v.val }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="funnel mt20 flex flex-column flex-center">
        <div
          class="funnel-row flex-1 flex flex-column flex-center ml20"
          v-for="(v, i) in h"
          :key="i"
        >
          <div class="flex">{{ v.name }}</div>
          <div>{{ v.val }}</div>
          <div class="tit">{{ v.name }}</div>
          <div class="cover-notice">
            转化率
            <div>{{ v.chance }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="trend">
      <ve-line :data="chartData"></ve-line>
    </div>

    <div class="msg-push-info">
      <div class="tabForm_top">
        <i class="tabForm_top_col"></i>
        <span class="tabForm_top_title">推荐商品详情</span>
      </div>
      <el-table
        stripe
        border
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        id="table"
        size="small"
        @sort-change="sortthiscolumn"
      >
        <el-table-column
          prop="wxshopSpuName"
          label="商品信息"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="exposureCount"
          sortable
          label="曝光数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="clickCount"
          sortable
          label="点击数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="addCartCount"
          sortable
          label="加购物车"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sellCount"
          sortable
          label="销售件数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="payOrderCount"
          label="销售订单数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="exposurePayOrderCount"
          sortable
          label="曝光-支付转化率"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.exposurePayOrderCount }}%
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >商品详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import VeLine from "v-charts/lib/line.common";

export default {
  components: {
    VeLine
  },
  data() {
    return {
      timeTable: 1,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      totalPage: 1,
      order: "",
      orderType: "",
      tableData: [],
      chartData: {
        columns: [
          "dateValue",
          "曝光商品",
          "点击数",
          "曝光-点击率",
          "支付金额",
          "支付订单数"
        ],
        rows: []
      },
      dayNum: false,
      initiali: {},
      pkTime1: "",
      pkTime2: "",
      timeQuantumType: "hour",
      queryStartTime: "",
      queryEndTime: "",
      taday: "",
      yesterday: "", // 昨天
      storeCode: "",
      paramsInfo: null,
      pickerOptions: {
        disabledDate: time => {
          return (
            time.getTime() < new Date(this.row.planStartDate).getTime() - 8.64e7
          );
        }
      },
      planSkuRelModelList: [],
      planExecRecordModelList: [],
      h: [
        {
          name: "曝光商品",
          val: 0,
          chance: 0
        },
        {
          name: "点击商品",
          val: 0,
          chance: 0
        },
        {
          name: "加购商品",
          val: 0,
          chance: 0
        },
        {
          name: "支付订单",
          val: 0,
          chance: 0
        }
        // {
        //   name: "支付金额",
        //   val: 0,
        //   chance: 0,
        // }
      ],
      list: [
        {
          icon: "icon-fugairenshu",
          name: "商品曝光数",
          val: 0,
          tip: "统计时间内，商品通过猜你喜欢的展现次数",
          pathName: "ScheduledUserDetails",
          queryStatus: "cover"
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "商品点击数",
          val: 0,
          tip: "统计时间内，用户通过猜你喜欢点击商品的次数",
          pathName: "ScheduledUserDetails",
          queryStatus: "notice"
        },
        {
          icon: "icon-fangwenrenshu",
          name: "加购物车数",
          val: 0,
          tip: "统计时间内，通过猜你喜欢加入购物车的次数",
          pathName: "ScheduledUserDetails",
          queryStatus: "visit"
        },
        {
          icon: "icon-fukuanrenshu",
          name: "支付订单数",
          val: 0,
          tip: "统计时间内，通过猜你喜欢的支付订单数",
          pathName: "ScheduledUserDetails",
          queryStatus: "pay"
        },
        {
          icon: "icon-fukuanjine",
          name: "支付金额",
          val: 0,
          tip: "统计时间内，通过猜你喜欢的支付金额",
          pathName: "ScheduledUserDetails",
          queryStatus: "pay"
        }
      ],
      createTimeArry: "",
      msgInfo: {
        img: "https://imgcdn.hemiao100.com/ThemePictures/defaultgood.png",
        goodsName: "惠氏三段新西兰进口羊奶粉 800g",
        time: "2020-12-04 12:00:00"
      },
      row: JSON.parse(this.$route.query.row),
      planInfoModel: {},
      coverNumRatio: "0%",
      noticeNumVisRatio: "0%",
      noticeNumRatio: "0%",
      payNumRatio: "0%"
    };
  },
  computed: {},
  watch: {},
  created() {
    this.paramsInfo = JSON.parse(this.$route.query.row);
    this.storeCode = this.$route.query.storeCode;

    let curDate = new Date();
    let preDate = new Date(curDate.getTime() - 1 * 24 * 60 * 60 * 1000); //前一天
    let preDate2 = new Date(curDate.getTime() - 2 * 24 * 60 * 60 * 1000); //前一天
    this.queryStartTime = this.formatDateTime(preDate);
    this.queryEndTime = this.queryStartTime;
    this.yesterday = this.formatDateTime(preDate);
    this.taday = this.formatDateTime(new Date(curDate.getTime()));
    this.pkTime2 = this.formatDateTime(preDate2);
    this.createTimeArry = [this.yesterday, this.yesterday];
    this.getStatistics();
    this.getEchartsList();
    this.getDetailGoods();
  },
  methods: {
    //  计划运营数据
    async getStatistics() {
      let res = await this.$store.dispatch("recommendDetailGeneral", {
        timeQuantumType: this.timeQuantumType,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        storeCode: this.storeCode,
        path: this.paramsInfo.path
      });

      if (res.result) {
        let result = res.result;
        console.log("result----", result);
        this.list[0].val = result.exposureCount;
        this.list[1].val = result.clickCount;
        this.list[2].val = result.addCartCount;
        this.list[3].val = result.payOrderCount;
        this.list[4].val = result.payMoney;
        this.h[0].val = result.comparisonExposureCount;
        this.h[1].val = result.comparisonClickCount;
        this.h[2].val = result.comparisonExposureClickCount;
        this.h[3].val = result.comparisonPayOrderCount;
        // this.h[4].val = result.comparisonPayMoney;
      }
    },
    // 切换选择时间
    oldData(time) {
      this.createTimeArry = "";
      let curDate = new Date();
      let preDate1 = new Date(curDate.getTime() - 1 * 24 * 60 * 60 * 1000); //前1天
      let preDate2 = new Date(curDate.getTime() - 2 * 24 * 60 * 60 * 1000); //前2天
      let preDate7 = new Date(curDate.getTime() - 7 * 24 * 60 * 60 * 1000); //前7天
      let preDate8 = new Date(curDate.getTime() - 8 * 24 * 60 * 60 * 1000); //前8天
      let preDate15 = new Date(curDate.getTime() - 15 * 24 * 60 * 60 * 1000); //前14天
      let preDate30 = new Date(curDate.getTime() - 30 * 24 * 60 * 60 * 1000); //前30天
      let preDate31 = new Date(curDate.getTime() - 31 * 24 * 60 * 60 * 1000); //前30天
      let preDate61 = new Date(curDate.getTime() - 61 * 24 * 60 * 60 * 1000); //前61天
      this.queryEndTime = this.yesterday;
      if (time == 1) {
        this.dayNum = false;
        this.queryStartTime = this.formatDateTime(preDate1);
        this.pkTime2 = this.formatDateTime(preDate2);
        this.timeQuantumType = "hour";
        this.timeTable = 1;
      }
      if (time == 7) {
        this.dayNum = true;
        this.queryStartTime = this.formatDateTime(preDate7);
        this.pkTime1 = this.formatDateTime(preDate15);
        this.pkTime2 = this.formatDateTime(preDate8);
        this.timeQuantumType = "date";
        this.timeTable = 2;
      }
      if (time == 30) {
        this.dayNum = true;
        this.queryStartTime = this.formatDateTime(preDate30);
        this.pkTime1 = this.formatDateTime(preDate61);
        this.pkTime2 = this.formatDateTime(preDate31);
        this.timeQuantumType = "date";
        this.timeTable = 3;
      }
      this.createTimeArry = [this.queryStartTime, this.queryEndTime];
      this.getStatistics();
      this.getEchartsList();
      this.getDetailGoods();
    },
    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d;
    },
    // 计算day差
    getDaysBetween(dateString1, dateString2) {
      var startDate = Date.parse(dateString1);
      var endDate = Date.parse(dateString2);
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      return days;
    },
    // 计算 指定的日期函数
    getBeforeDate(num, time) {
      let n = num;
      let d = "";
      if (time) {
        d = new Date(time);
      } else {
        d = new Date();
      }
      let year = d.getFullYear();
      let mon = d.getMonth() + 1;
      let day = d.getDate();
      if (day <= n) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - n);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    // 日历
    createTimeArryChange() {
      this.getEchartsList();
      this.getDetailGoods();
    },
    // 图表接口
    async getEchartsList() {
      const { result } = await this.$store.dispatch("getEcharts", {
        timeQuantumType: this.timeQuantumType,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        storeCode: this.storeCode,
        path: this.paramsInfo.path
      });
      console.log("图表-----", result);
      this.chartData.rows = result;
      let broLine = result;
      let list = [];
      broLine.forEach(item => {
        list.push({
          dateValue: item.timeQuantum,
          曝光商品: item.exposureCount,
          商品点击数: item.clickCount,
          商品点击率: item.comparisonClickCount,
          加入购物车数: item.stayTimeUv,
          支付订单数: item.payOrderCount
          // 曝光:-支付转化率: item.
        });
      });
      console.log("list------", list);
      this.chartData.rows = list;
    },
    // 表格接口
    async getDetailGoods() {
      let res = await this.$store.dispatch("getDetailGoods", {
        timeQuantumType: this.timeQuantumType,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        storeCode: this.storeCode,
        path: this.paramsInfo.path,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        orderType: this.orderType,
        order: this.order
      });
      if (res.result) {
        this.tableData = res.result.list;
        this.total = res.result.total;
      }
    },
    // 表格排序
    sortthiscolumn(column) {
      console.log("column----", column);
      if (column.prop === "exposureCount" && column.order === "ascending") {
        this.order = "exposure";
        this.orderType = "asc";
      } else if (
        column.prop === "exposureCount" &&
        column.order === "descending"
      ) {
        this.order = "exposure";
        this.orderType = "desc";
      }

      if (column.prop === "clickCount" && column.order === "ascending") {
        this.order = "click";
        this.orderType = "asc";
      } else if (
        column.prop === "clickCount" &&
        column.order === "descending"
      ) {
        this.order = "click";
        this.orderType = "desc";
      }

      if (column.prop === "addCartCount" && column.order === "ascending") {
        this.order = "addCart";
        this.orderType = "asc";
      } else if (
        column.prop === "addCartCount" &&
        column.order === "descending"
      ) {
        this.order = "addCart";
        this.orderType = "desc";
      }

      if (column.prop === "sellCount" && column.order === "ascending") {
        this.order = "sell";
        this.orderType = "asc";
      } else if (column.prop === "sellCount" && column.order === "descending") {
        this.order = "sell";
        this.orderType = "desc";
      }

      if (
        column.prop === "exposurePayOrderCount" &&
        column.order === "ascending"
      ) {
        this.order = "order";
        this.orderType = "asc";
      } else if (
        column.prop === "exposurePayOrderCount" &&
        column.order === "descending"
      ) {
        this.order = "order";
        this.orderType = "desc";
      }
      this.getDetailGoods();
    },
    paging(page) {
      console.log("paging----", page);
      this.currentPage = page;
      this.getDetailGoods();
    },
    handleSizeChange(size) {
      console.log("handleSizeChange----", size);
      this.currentPage = 1;
      this.pageSize = size;
      this.getDetailGoods();
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
    handleClick(v) {
      this.$router.push({
        name: "EditMicroShopGoods",
        query: {
          wxshopSpuId: v.wxshopSpuId
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.msg-push-info {
  background: #fff;
  margin-bottom: 10px;
  padding: 20px;
  .img {
    width: 66px;
  }
}
.title {
  color: #222222;
  font-weight: bold;
  margin-bottom: 18px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.msg-info {
  > div {
    font-size: 14px;
    color: #222;
  }
}
.purchase-data {
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 22px;
    font-weight: bold;
  }
}
.funnel {
  background-image: url("https://imgcdn.hemiao100.com/ThemePictures/%E6%BC%8F%E6%96%97%E5%9B%BE%402x444.png");
  height: 380px;
  background-size: 98% 100%;
  position: relative;
  background-repeat: no-repeat;
  .funnel-row {
    position: relative;
    line-height: 24px;
    .tit {
      position: absolute;
      right: 28%;
      color: #fff;
    }
    :nth-child(3) {
      right: 27%;
    }
  }
  .cover-notice {
    position: absolute;
    top: 36%;
    right: 4.5%;
    font-size: 14px;
  }
  .cover-access {
    position: absolute;
    top: 45%;
    right: 8%;
    font-size: 14px;
  }
  .notice-purchase {
    position: absolute;
    bottom: 19%;
    right: 10%;
    font-size: 14px;
  }
  .cover-purchase {
    position: absolute;
    bottom: 40%;
    font-size: 14px;
    right: 2%;
  }
}
.trend {
  margin-top: 10px;
  padding: 10px 20px;
  background: #ffffff;
}
.tabForm_top {
  width: 100%;
  height: 40px;
  .tabForm_top_col {
    height: 22px;
    width: 3px;
    background: red;
    display: inline-block;
  }
  .tabForm_top_title {
    font-size: 16px;
    display: inline-block;
    margin: 0 10px;
  }
  .tabForm_top_text {
    font-size: 14px;
    color: #999;
  }
}
.button-activy {
  background-color: #e50065;
  border-color: #e50065;
}

.not-button-activy {
  background-color: white;
  border-color: #e50065;
  color: black;
}
</style>
